const UseFormUtils = require('./core');

const UseFormLayoutUtils = module.exports = {};

UseFormLayoutUtils.sortByOrder = (items = []) => {

    return items.slice().sort((a, b) => {

        return (a.order || 0) - (b.order || 0);
    });
};

UseFormLayoutUtils.isVisible = ({
    item,
    context,
    conditionTypes
}) => {

    return UseFormUtils.evaluateCondition({
        condition: item.visibleWhen,
        context: {
            ...context,
            item
        },
        conditionTypes
    });
};

UseFormLayoutUtils.filterVisible = ({
    items = [],
    context,
    conditionTypes
}) => {

    return items.filter((item) => UseFormLayoutUtils.isVisible({
        item,
        context,
        conditionTypes
    }));
};

UseFormLayoutUtils.resolveLayout = ({
    items = [],
    context,
    conditionTypes
}) => {

    return UseFormLayoutUtils.sortByOrder(UseFormLayoutUtils.filterVisible({
        items,
        context,
        conditionTypes
    }));
};

UseFormLayoutUtils.applyLayoutToGroups = ({
    groups = [],
    layout = [],
    context,
    conditionTypes
}) => {

    const groupsByName = groups.reduce((collector, group) => {

        collector[group.name] = group;
        return collector;
    }, {});

    return UseFormLayoutUtils.resolveLayout({
        items: layout,
        context,
        conditionTypes
    }).map((layoutItem) => {

        return {
            ...groupsByName[layoutItem.name],
            ...layoutItem
        };
    }).filter((group) => !!group.name);
};
